<template>
  <el-form label-position="top">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">商品信息</template>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="商品名称:"> {{ product.productName }} <span v-if="product.productNameRemark"> ({{ product.productNameRemark }})</span> </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品编号:"> {{ product.productNumber }} </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品类型:"> {{ product.categoryName }} </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓库名称:">
            <span v-if="$route.query.warehouseName"> {{ $route.query.warehouseName }}（{{ $route.query.warehouseNo }}）</span>
            <span v-else> {{ batchInfo.warehouseName }}（{{ batchInfo.warehouseNo }}）</span>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="商品系列:"> {{ product.productLineName }} </el-form-item>
        </el-col> -->
        <!-- <el-col :span="8">
          <el-form-item label="贸易类型:"> {{ product.tradeType | tradeType() }} </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标签类型:"> {{ product.tagType | tagType() }} </el-form-item>
        </el-col> -->
        <!-- <el-col :span="8">
        <el-form-item label="赋码方式:"> {{product.codingType | codingType()}} </el-form-item>
      </el-col> -->
      </el-row>
    </layout-card-wrap>
  </el-form>
</template>

<script>
export default {
  name: 'ProductInfo',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    batchInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    product: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
